export const TIMESTAMP_KEY = 'userTimestamp';

export const setUserTimestamp = (): void => {
  const date = new Date();
  const isUserTimestampAvail = localStorage.getItem(TIMESTAMP_KEY);
  if (!isUserTimestampAvail) {
    localStorage.setItem(TIMESTAMP_KEY, date.toISOString());
  }
};

export function getUserTimestamp(): string | null {
  return localStorage.getItem(TIMESTAMP_KEY);
}
